import _00_45redirect_45global from "/myapp/frontend/middleware/00.redirect.global.ts";
import _01_45ip_45global from "/myapp/frontend/middleware/01.ip.global.ts";
import _02_45params_45global from "/myapp/frontend/middleware/02.params.global.ts";
import _03_45partner_45global from "/myapp/frontend/middleware/03.partner.global.ts";
import _06_45conf_45global from "/myapp/frontend/middleware/06.conf.global.ts";
import _07_45ab_45global from "/myapp/frontend/middleware/07.ab.global.ts";
import _10_45tracking_45global from "/myapp/frontend/middleware/10.tracking.global.ts";
import manifest_45route_45rule from "/myapp/node_modules/.pnpm/nuxt@3.18.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@20.10.5_@vue+compile_45dfabe6906a4800269a5e6d3da88dc8/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  _00_45redirect_45global,
  _01_45ip_45global,
  _02_45params_45global,
  _03_45partner_45global,
  _06_45conf_45global,
  _07_45ab_45global,
  _10_45tracking_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}